/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { tenantResponseDtoSchema } from "../tenantResponseDtoSchema";
import { updateTenantStatusDtoSchema } from "../updateTenantStatusDtoSchema";
import { z } from "zod/v4";

export const updateTenantStatusHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Updated tenant opt-in/opt-out preferences
 */
export const updateTenantStatus200Schema = z.lazy(() => tenantResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const updateTenantStatus401Schema = z.any()

export const updateTenantStatusMutationRequestSchema = z.lazy(() => updateTenantStatusDtoSchema)

export const updateTenantStatusMutationResponseSchema = z.lazy(() => updateTenantStatus200Schema)